/**
 * 런타임 설정.
 * 백엔드 URL 은 하드코딩하지 않고 `import.meta.env` 로 주입받는다.
 * 기본값은 개발 서버가 프록시하는 상대 경로다 (브라우저는 항상 한 오리진만 본다).
 */
const API_BASE = (import.meta.env.VITE_API_BASE || "/api/v1").replace(/\/$/, "")

/** 목록 기본 페이지 크기 */
const PAGE_SIZE = 10

export { API_BASE, PAGE_SIZE }
